import { render, staticRenderFns } from "./ProfitExtractRecord.vue?vue&type=template&id=e2535da8&scoped=true&"
import script from "./ProfitExtractRecord.vue?vue&type=script&lang=js&"
export * from "./ProfitExtractRecord.vue?vue&type=script&lang=js&"
import style0 from "./ProfitExtractRecord.vue?vue&type=style&index=0&id=e2535da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2535da8",
  null
  
)

export default component.exports